import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { processRefundRequest } from '../../services/api/get-pharmacy-orders';

function RefundBankAmountModal({ onClose }) {
  const [formData, setFormData] = useState({ transactionId: '', orderId: '', amount: '' });
  const [validationErrors, setValidationErrors] = useState({ idField: '', amount: '' });
  const [disableButton, setDisableButton] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const errors = { idField: '', amount: '' };
    const { transactionId, orderId, amount } = formData;

    if (!transactionId.trim() && !orderId.trim()) {
      errors.idField = 'Provide either a Transaction ID or an Order ID';
    } else if (transactionId.trim() && isNaN(transactionId)) {
      errors.idField = 'Transaction ID must be a number';
    } else if (orderId.trim() && isNaN(orderId)) {
      errors.idField = 'Order ID must be a number';
    }

    if (!amount.trim() || isNaN(amount)) {
      errors.amount = 'Amount must be a number';
    } else if (Number(amount) <= 0) {
      errors.amount = 'Amount must be greater than 0';
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    setValidationErrors(errors);
    if (errors.idField || errors.amount) return;

    setDisableButton(true);
    const payload = { amount: Number(formData.amount) };
    if (formData.transactionId.trim()) payload.transactionId = Number(formData.transactionId);
    if (formData.orderId.trim()) payload.orderId = Number(formData.orderId);

    const response = await processRefundRequest(payload);
    setDisableButton(false);
    if (response && response.success) {
      alert('Bank refund processed successfully');
      onClose();
    } else {
      alert(response?.message || 'Refund failed. Please try again.');
    }
  };

  return (
    <Modal isOpen={true} style={{ maxWidth: '600px', width: '100%' }}>
      <ModalHeader style={{ backgroundColor: '#8752CC' }} toggle={onClose}>
        <h4 className="text-center" style={{ color: '#fff', fontWeight: 'bold' }}>Refund Bank Amount</h4>
      </ModalHeader>
      <ModalBody style={{ padding: '20px 40px' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="transactionId">Transaction ID:</label>
            <input
              type="number"
              id="transactionId"
              name="transactionId"
              className="form-control"
              value={formData.transactionId}
              onChange={handleChange}
            />
          </div>
          <div className="text-center mb-2" style={{ fontWeight: 'bold', color: '#555' }}>— OR —</div>
          <div className="form-group">
            <label htmlFor="orderId">Order ID:</label>
            <input
              type="number"
              id="orderId"
              name="orderId"
              className="form-control"
              value={formData.orderId}
              onChange={handleChange}
            />
          </div>
          {validationErrors.idField && (
            <span className="text-danger d-block mb-2">{validationErrors.idField}</span>
          )}
          <div className="form-group">
            <label htmlFor="amount">Amount:</label>
            <input
              type="number"
              id="amount"
              name="amount"
              className="form-control"
              value={formData.amount}
              onChange={handleChange}
              required
            />
            <span className="text-danger">{validationErrors.amount}</span>
          </div>
          <div className="text-center">
            <button type="submit" className="btn btn-primary" disabled={disableButton}>
              {disableButton ? 'Processing...' : 'Refund Bank Amount'}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}

export default RefundBankAmountModal;
